import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class RouterDataService {
    private _data: any = null;

    get data() {
        return this._data;
    }

    setData(data: any) {
        this._data = data;
    }
}
